/** Clear stale Occasia JWT and prompt the user to sign in again. */
export const clearOccasiaSession = () => {
  try {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  } catch {
    // ignore storage errors
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('occasiaSessionCleared'));
  }
};

export const promptOccasiaSignIn = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('openLoginModal'));
  }
};

export const isPaymentSessionAuthError = (message) => {
  const lower = String(message || '').toLowerCase();
  return (
    lower.includes('session has expired') ||
    lower.includes('token has expired') ||
    lower.includes('invalid token') ||
    lower.includes('not authenticated') ||
    lower.includes('not authorised') ||
    lower.includes('no login session found') ||
    lower.includes('please sign in to continue') ||
    lower.includes('sign in with the email address')
  );
};

export const recoverPaymentSession = () => {
  clearOccasiaSession();
  promptOccasiaSignIn();
};
